import React from "react";
import user08 from "../../assets/UserPanelAssets/img/users/user-08.jpg";

export default function ProfileSettings() {
  return (
    <div className="content">
      {/* Page Header */}
      <div className="mb-3 border-bottom pb-3">
        <h4 className="fw-bold mb-0">Settings</h4>
      </div>

      <div className="card" id="profilePage">
        <div className="card-body">
          <div className="row">
            {/* Right Section */}
            <div className="col-lg-12">
              <div className="border-1 border-start ps-4">
                <h5 className="fw-bold pb-3 mb-4 border-1 border-bottom">
                  Basic Information
                </h5>

                {/* Profile Image */}
                <div className="row border-bottom mb-3">
                  <div className="col-lg-12">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-2">
                        <label className="form-label mb-0">
                          Profile Image{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                      </div>

                      <div className="col-lg-10">
                        <div className="profile-container">
                          <img src={user08} alt="Profile" />
                          <div className="overlay-btn">
                            <a
                              href="javascript:void(0);"
                              className="text-white"
                              id="uploadTrigger"
                            >
                              <i className="ti ti-photo fs-10"></i>
                            </a>
                          </div>
                          <input
                            type="file"
                            id="profileUpload"
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* First Name */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          First Name <span className="text-danger ms-1">*</span>
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          Last Name <span className="text-danger ms-1">*</span>
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          Email <span className="text-danger ms-1">*</span>
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          Phone Number{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Address Section */}
                <div className="row border-bottom mb-3">
                  <div className="mb-3">
                    <h5 className="fw-bold mb-0">Address Information</h5>
                  </div>

                  {/* Address 1 */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          Address Line 1
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  {/* Address 2 */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">
                          Address Line 2
                        </label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  {/* Country */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">Country</label>
                      </div>
                      <div className="col-lg-8">
                        <select className="select">
                          <option>Select</option>
                          <option>USA</option>
                          <option>Canada</option>
                          <option>UK</option>
                          <option>Germany</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* State */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">State</label>
                      </div>
                      <div className="col-lg-8">
                        <select className="select">
                          <option>Select</option>
                          <option>California</option>
                          <option>Ontario</option>
                          <option>England</option>
                          <option>Bavaria</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">City</label>
                      </div>
                      <div className="col-lg-8">
                        <select className="select">
                          <option>Select</option>
                          <option>Los Angeles</option>
                          <option>Toronto</option>
                          <option>London</option>
                          <option>Munich</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Pincode */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-4">
                        <label className="form-label mb-0">Pincode</label>
                      </div>
                      <div className="col-lg-8">
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end align-items-center gap-2">
                  <button className="btn btn-light btn-md fs-13 fw-medium rounded">
                    Cancel
                  </button>
                  <button className="btn btn-primary btn-md fs-13 fw-medium rounded">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
